import type { ScrollHelper } from '@op/react-web'
import { createContext } from 'react'

export type AppScrollCtx = {
	add(id: string, $scrollEl?: HTMLElement): ScrollHelper
	remove(id: string): void
}

export const AppScrollContext = createContext<AppScrollCtx>(null as any)
